export default __webpack_public_path__ + "img/574b512553600c4a6dbe06e26dbb13bc.svg";